export const lenisScroll = (target) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { duration: 1.6 });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const goToAnchor = (href, navigate, pathname) => {
  const path = pathname ?? window.location.pathname;
  if (path !== "/") {
    sessionStorage.setItem("vc-anchor", href);
    if (navigate) navigate("/");
    else window.location.href = "/";
  } else {
    lenisScroll(href);
  }
};
